import { Modal, useTranslation } from '@nextgen-web-framework/all';
import { ChangeUsernameModalProps } from './types/propTypes';
import styles from './ChangeUsernameModal.module.scss';

const ChangeUsernameModal = (props: ChangeUsernameModalProps) => {
  const t = useTranslation();
  const { isUsernameEmail, onSecondaryButtonClick, onPrimaryButtonClick } = props;

  const ModalText = isUsernameEmail
    ? t('profile.ChangeUsernameModal.modalTextEmail')
    : t('profile.ChangeUsernameModal.modalTextMobile');
  return (
    <div className={styles['change-username-modal']} data-testid="change-username-modal">
      <Modal
        headline={t('profile.ChangeUsernameModal.headline')}
        primaryButtonLabel={t('profile.ChangeUsernameModal.primaryButton')}
        secondaryButtonLabel={t('profile.ChangeUsernameModal.secondaryButton')}
        onSecondaryButtonClick={onSecondaryButtonClick}
        onPrimaryButtonClick={onPrimaryButtonClick}
        onClose={onSecondaryButtonClick}
      >
        <span data-testid="changeEmail-username-test-id">{ModalText}</span>
      </Modal>
    </div>
  );
};

export default ChangeUsernameModal;
